import React, { useState, useEffect, useContext } from "react";
// import NeshanMap from "react-neshan-map-leaflet";
import "./Nav2&Foot2.scss";
import location from "../../assets/images/Icon metro-location.png";
import whatsapp from "../../assets/images/Icon simple-whatsapp.png";
import instagram from "../../assets/images/Icon simple-instagram.png";
import twitter from "../../assets/images/Icon feather-twitter.png";
import telegram from "../../assets/images/icons8-telegram-app-50.png";

import call from "../../assets/images/Icon ionic-ios-call-blue.png";
import { connection } from "utils/apiConnection.ts";
import { useParams } from "react-router-dom";
import BusinessContext from "context/BusinessContext";
const Footer2 = () => {
  const params = useParams();
  const [contactF, setContactF] = useState();
  const [business, setBusiness] = useState();
  async function apihandler() {
    let shopSuffix = params.shop_suffix;
    let keyvalues = {
      shopSuffix,
    };
    let business = await connection("getshopinfo", keyvalues);
    setBusiness(business.result);
  }
  useEffect(() => {
    if (business) {
      setContactF({
        name: business.title,
        tell: business.tell,
        mobile: business.mobile,
        socialMedia: JSON.parse(business.other_params).socialMedia,
      });
    }
  }, [business]);
  const { setContact } = useContext(BusinessContext);
  useEffect(() => {
    apihandler();
  }, []);
  return (
    <>
      {business ? (
        <div className="footer row">
          <div className="col-12 row d-flex justify-content-lg-evenly">
            {/* <div>{business.title}</div> */}
            <div
              style={{ display: "flex", justifyContent: "center" }}
              className="col-12 col-md-6 col-lg-4"
            >
              {contactF
                ? contactF.socialMedia.map((value, index) => {
                    return parseInt(value.selectField) == 1 ? (
                      <a
                        href={`https://www.instagram.com/${value.nameField}`}
                        className="roundIcon"
                        style={{ backgroundColor: "#F23041" }}
                        key={index}
                      >
                        <img src={instagram} alt="instagram" />
                      </a>
                    ) : parseInt(value.selectField) == 2 ? (
                      <a
                        key={index}
                        href={`https://t.me/s/${value.nameField}`}
                        className="roundIcon"
                        style={{
                          backgroundColor: "#29B6F6",
                        }}
                      >
                        <img
                          src={telegram}
                          alt="telegram"
                          style={{ width: "36px", height: "36px" }}
                        />
                      </a>
                    ) : parseInt(value.selectField) == 3 ? (
                      <a
                        href={`https://wa.me/${value.nameField}`}
                        className="roundIcon"
                        style={{ backgroundColor: "#56A689" }}
                        key={index}
                      >
                        <img src={whatsapp} alt="whatsapp" />
                      </a>
                    ) : parseInt(value.selectField) == 4 ? (
                      <a
                        href={`https://twitter.com/${value.nameField}`}
                        className="roundIcon"
                        style={{ backgroundColor: "#4B53F2" }}
                        key={index}
                      >
                        <img src={twitter} alt="twitter" />
                      </a>
                    ) : (
                      ""
                    );
                  })
                : ""}
            </div>
            <br />
            <div className="col-12 col-md-6 col-lg-4">
              <div>دستیابی سریع</div>
              <a
                href="#contact"
                data-bs-toggle="modal"
                data-bs-target="#ModalContact"
                onClick={(e) => setContact(contactF)}
              >
                <img src={call} alt="call" /> شماره های تماس
              </a>
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              {business.address_text != "" ? (
                <>
                  <img src={location} alt="location" /> آدرس :{" "}
                  {business.address_text} فروشگاه {business.title}
                </>
              ) : (
                ""
              )}
            </div>
          </div>

          {/* <NeshanMap
        options={{
          key: "web.AdlXTMqxj6zuqtBfgTG1XRvK8WdlFpF64OrikNlj",
          maptype: "dreamy",
          poi: true,
          traffic: false,
          center: [35.699739, 51.338097],
          zoom: 13,
        }}
      /> */}
        </div>
      ) : (
        ""
      )}
    </>
  );
};

export default Footer2;
